// extracted by mini-css-extract-plugin
module.exports = {"root":"toolbar_root__250d1","toggleButton":"toolbar_toggleButton__6w53R","closeButton":"toolbar_closeButton__sfUq0","signInButton":"toolbar_signInButton__xBBEd"};